import { render, staticRenderFns } from "./searchArea.vue?vue&type=template&id=ef0b23ae&scoped=true"
import script from "./searchArea.vue?vue&type=script&lang=js"
export * from "./searchArea.vue?vue&type=script&lang=js"
import style0 from "./searchArea.vue?vue&type=style&index=0&id=ef0b23ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b23ae",
  null
  
)

export default component.exports